// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10c_t","placeholdersHeader":"styles_placeholdersHeader__i7j74","editorStyle":"styles_editorStyle__1VCkn","placeholdersBox":"styles_placeholdersBox__3k0EG"};